<template>
  <main>
    <h1>
      <v-icon v-if="isEdit" class="teams-icon" color="success" medium
        >mdi-pencil</v-icon
      >
      <v-icon
        v-else
        class="teams-icon icon-user"
        color="success"
        medium
      ></v-icon>
      <span v-if="isEdit">Edit Parent</span>
      <span v-else>New Parent</span>
      <!-- {{ governorates }} -->
    </h1>
    <v-row>
      <v-col lg="10" class="mx-auto">
        <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
          <p
            class="mb-0"
            v-for="globalErr in globalServerErrors"
            :key="globalErr"
          >
            {{ globalErr[0] }}
          </p>
        </v-alert>
        <!-- {{ countries }} -->
        <formWrapper :validator="$v.form">
          <form @submit.prevent="handleSave" class="form-box">
            <v-row>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="first_name" :attribute="`fields.first_name`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.first_name"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="last_name" :attribute="`fields.last_name`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.last_name"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="email" :attribute="`fields.email`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.email"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="mobile" :attribute="`fields.mobile`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.mobile"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="relation" attribute="fields.relation">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="relations"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.relation.id"
                    ></v-select>
                    <!-- @input="selectedRelation" -->
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="clothes_size" attribute="fields.clothes_size">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :loading="loadingData"
                      :items="clothes"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.clothes_size.id"
                    ></v-select>
                    <!-- @input="selectedClothesSize" -->
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <!-- :loading="loadingCountries"
                  :disabled="loadingCountries" -->
                <v-select
                  :items="countries"
                  label="Countries"
                  item-text="name"
                  item-value="id"
                  regular
                  return-object
                  clearable
                  v-model="form.country"
                  @change="selectedCountryChange"
                ></v-select>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="governorate" attribute="fields.governorate">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :loading="loadingData"
                      :items="governorates"
                      :disabled="governorates.length == 0"
                      item-text="name"
                      item-value="id"
                      regular
                      return-object
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.governorate"
                      @change="selectedGovernorateChange"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-select
                  :loading="loadingData"
                  :items="areas"
                  :disabled="areas.length == 0"
                  item-text="name"
                  item-value="id"
                  label="Area"
                  regular
                  return-object
                  clearable
                  v-model="form.area"
                ></v-select>
              </v-col>
              <v-col class="py-0 dates prepend" cols="12" md="6">
                <v-dialog
                  ref="birthdateDialog"
                  v-model="birth_date_modal"
                  :return-value.sync="form.birth_date.date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.birth_date.date"
                      label="Birthdate"
                      readonly
                      v-on="on"
                      @click:append="clearBirthDate()"
                      append-icon="mdi-close"
                      prepend-icon="icon-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.birth_date.date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="birth_date_modal = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.birthdateDialog.save(form.birth_date.date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col class="py-0" cols="12" sm="12">
                <form-group name="address" :attribute="`fields.address`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.address"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group
                  name="job_position"
                  :attribute="`fields.job_position`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.job_position"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="employer" :attribute="`fields.employer`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.employer"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field
                  readonly
                  :label="$t('fb_android_token')"
                  regular
                  v-model.trim="form.fb_android_token"
                  type="text"
                  :prepend-icon="'mdi-content-copy'"
                  @click:prepend="hadnleCopy(form.fb_android_token)"
                >
                </v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field
                  @click:prepend="hadnleCopy(form.fb_ios_token)"
                  :prepend-icon="'mdi-content-copy'"
                  readonly
                  :label="$t('fb_ios_token')"
                  regular
                  v-model.trim="form.fb_ios_token"
                  type="text"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="success text-capitalize"
                  large
                  type="submit"
                  width="30%"
                  :disabled="!isEdit && $v.form.$invalid"
                >
                  <span>Save</span></v-btn
                >
                <v-btn text large color="primary" class="ml-2" to="/accounts"
                  >Cancel</v-btn
                >
              </v-col>
            </v-row>
          </form>
        </formWrapper>
      </v-col>
    </v-row>
  </main>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData,
} from "@/helpers/apiMethods";
export default {
  data() {
    return {
      form: {
        account: this.$route.query.account,
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        relation: {
          id: "",
          name: "",
        },
        clothes_size: {
          id: "",
          name: "",
        },
        country: null,
        governorate: null,
        area: null,
        birth_date: { date: "" },
        address: "",
        job_position: "",
        employer: "",
      },
      birth_date_modal: false,
      relations: [],
      clothes: [],
      countries: [],
      // areas: [],
      // governorates: [],
      loadingData: false,
      loadingCountries: false,
      isEdit: false,
      globalServerErrors: null,
    };
  },
  created() {
    this.indexCountries();
    this.indexRelations();
    this.indexClothesSizes();
    this.editCreateBoolean();
    // if (this.isEdit === true) {
    //   this.handleParentData();
    // }
  },
  computed: {
    governorates() {
      // if()
      if (this.form.country !== null) {
        const country = this.form.country;
        let governorates = [];
        this.countries.find((item) => {
          if (item.id === country.id) {
            governorates = item.governorates;
          }
        });
        return governorates;
      } else {
        return [];
      }
    },
    areas() {
      if (this.governorates.length > 0) {
        if (this.form.country !== null && this.form.governorate !== null) {
          let areas = [];
          const governorateId = this.form.governorate;
          this.governorates.find((governorate) => {
            if (governorate.id === governorateId.id) {
              areas = governorate.areas;
            }
          });
          return areas;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
  },
  methods: {
    hadnleCopy(textContent) {
      this.$copyText(textContent).then(() => {
        this.clipboardAlert();
      });
    },
    indexRelations() {
      IndexData({ reqName: `/family-relations` })
        .then((res) => {
          const { data } = res.data;
          this.relations = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexClothesSizes() {
      IndexData({ reqName: `/clothes-sizes` })
        .then((res) => {
          const { data } = res.data;
          this.clothes = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexCountries() {
      this.loadingCountries = true;
      IndexData({ reqName: `/countries` })
        .then((res) => {
          this.countries = res.data.data;
          this.loadingCountries = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      this.$route.params.id ? this.editParent() : this.addParent();
    },
    addParent() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD";
      this.form.birth_date = {
        date: this.$moment(this.form.birth_date.date).format(dateFormat),
      };

      Object.keys(this.form).forEach((formItem) => {
        if (
          formItem === "relation" ||
          formItem === "clothes_size" ||
          formItem === "country" ||
          formItem === "governorate" ||
          formItem === "area"
        ) {
          formData.append(formItem, this.form[formItem].id);
        } else if (formItem === "birth_date") {
          formData.append(formItem, this.form[formItem].date);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      StoreData({
        reqName: `parents`,
        data: formData,
      })
        .then(() => {
          history.go(-1);
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editParent() {
      const formData = new FormData();
      Object.keys(this.form).forEach((formItem) => {
        if (
          formItem === "account_id" ||
          formItem === "account_no" ||
          formItem === "master" ||
          formItem === "code" ||
          formItem === "national_id" ||
          formItem === "status" ||
          formItem === "historical_member"
        ) {
          return;
        }
        if (
          formItem === "relation" ||
          formItem === "clothes_size" ||
          formItem === "country"
        ) {
          formData.append(formItem, this.form[formItem].id);
        } else if (formItem === "governorate" && this.form[formItem] == null) {
          delete this.form[formItem];
        } else if (formItem === "area" && this.form[formItem] == null) {
          delete this.form[formItem];
        } else if (formItem === "governorate" && this.form[formItem] != null) {
          formData.append(formItem, this.form[formItem].id);
        } else if (formItem === "area" && this.form[formItem] != null) {
          formData.append(formItem, this.form[formItem].id);
        } else if (formItem === "birth_date") {
          if (this.form[formItem] == null) {
            formData.append(formItem, "");
          } else {
            formData.append(formItem, this.form[formItem].date);
          }
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      formData.append("_method", "put");

      UpdateData({
        reqName: `parents`,
        data: formData,
        id: this.$route.params.id,
      })
        .then(() => {
          history.go(-1);
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleParentData(id) {
      ShowData({
        reqName: "parents",
        id: id,
      })
        .then((res) => {
          const { parent } = res.data;
          this.form = parent;
          if (parent.birth_date != null) {
            this.form.birth_date = {
              date: this.$moment(this.form.birth_date.date).format(
                "YYYY-MM-DD"
              ),
            };
          }
          this.form.fb_android_token = parent.fb_android_token;
          this.form.fb_ios_token = parent.fb_ios_token;
          if (parent.birth_date == null) {
            this.form.birth_date = { date: "" };
          }
          if (parent.clothes_size === null) {
            this.form.clothes_size = { id: "" };
          }
          if (parent.relation === null) {
            this.form.relation = { id: "" };
          }
          if (parent.job_position === null) {
            this.form.job_position = "";
          }
          if (parent.employer === null) {
            this.form.employer = "";
          }
          if (parent.mobile === null) {
            this.form.mobile = "";
          }
          this.form.country = parent.country;
          if (parent.governorate === null) {
            this.loadedParent.governorate = "";
          }
          if (parent.area === null) {
            this.loadedParent.area = "";
          }
        })
        .catch(() => {});
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    },
    selectedRelation(value) {
      this.form.relation = value;
      console.log(value);
    },
    selectedClothesSize(value) {
      // this.form.clothes_size = value;
      console.log(value);
    },
    selectedCountryChange() {
      this.form.governorate = null;
      this.form.area = null;
    },
    selectedGovernorateChange() {
      this.form.area = null;
    },
    clearBirthDate() {
      this.form.birth_date = { date: "" };
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "ParentEdit") {
          this.$nextTick(() => {
            this.indexCountries();
            this.handleParentData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    form: {
      first_name: {
        required,
        minLength: minLength(3),
      },
      last_name: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      mobile: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(14),
      },
      relation: {
        required,
      },
      clothes_size: {
        required,
      },
      address: {
        required,
        minLength: minLength(3),
      },
      governorate: {
        required: requiredIf((form) => {
          return form.country;
        }),
      },
      // area: {
      //   required: requiredIf(form => {
      //     return form.governorate;
      //   })
      // },
      job_position: {
        required,
        minLength: minLength(3),
      },
      employer: {
        required,
        minLength: minLength(3),
      },
    },
  },
};
</script>
